module.exports = __webpack_public_path__ + "img/zan.2b07bd05.png";